/**
 * ## keyboard control and shortcuts
 *
 * @module src/controllers/demo
 */

"use strict";

const moment = require("moment-timezone");
const l = require("../../common").localization;
const notification = require("../../components/notification");

const start = (kd) => {
  const msg = {
    position: "top",
    width: "90%",
    seconds: 4,
    h1: "Creating demo data...",
    body: "",
    buttons: [
      {
        description: l.translate("Ok"),
        value: "close",
      },
    ],
  };
  notification.create(msg, {}, (err2, value) => {
    notification.destroy();
  });
  // Read table numbers. Mark first 5 as seated.
  const loc = kd.doc("location")[0];
  const chartID = loc.chart;
  const tablesdata = kd.doc("chart", chartID)[0].tables;
  const templatedata = kd.doc("template", loc.template)[0];
  const validTables = [];
  for (let t = 0; t < tablesdata.length; ++t) {
    if (tablesdata[t].type !== "icon") {
      validTables.push(tablesdata[t].table);
    }
  }
  const opt = {
    loc,
    chartID,
    tablesdata,
    templatedata,
    validTables,
  };

  const data = [
    // seated
    {
      type: "seated",
      table: validTables[19],
      size: 12,
      name: "Frieda",
      minAhead: 20,
      tableStatus: 2,
      join: [
        {
          id: 1,
          table: validTables[18],
        },
        {
          id: 2,
          table: validTables[20],
        },
      ],
    },
    {
      type: "seated",
      table: validTables[0],
      size: 2,
      name: "John",
      minAhead: 60,
      tableStatus: 6,
      join: [],
    },
    {
      type: "seated",
      table: validTables[1],
      size: 2,
      name: "Nancy",
      minAhead: 15,
      tableStatus: 2,
      join: [],
    },
    {
      type: "seated",
      table: validTables[2],
      size: 2,
      name: "Rey",
      minAhead: 20,
      tableStatus: 2,
      join: [],
    },
    {
      type: "seated",
      table: validTables[3],
      size: 2,
      name: "Mateo",
      minAhead: 10,
      tableStatus: 2,
      join: [],
    },
    {
      type: "seated",
      table: validTables[4],
      size: 2,
      name: "Sofia",
      minAhead: 45,
      tableStatus: 2,
      join: [],
    },
    // wait list
    {
      type: "wait",
      size: 2,
      name: "Zabi",
      minAhead: 5,
      quoted: 10,
    },
    {
      type: "wait",
      size: 2,
      name: "Florence",
      minAhead: 3,
      quoted: 12,
    },
    {
      type: "wait",
      size: 4,
      name: "Jayden",
      minAhead: 10,
      quoted: 15,
    },
    {
      type: "wait",
      size: 6,
      name: "Juliet",
      minAhead: 12,
      quoted: 20,
    },
    {
      type: "wait",
      size: 11,
      name: "Xenial Group",
      minAhead: 20,
      quoted: 35,
    },
    // reservaitons
    {
      type: "reservation",
      size: 4,
      name: "Mark Boyd",
      email: "mark@othermail.com",
      date: parseInt(moment().startOf("day").format("X"), 10),
      time: 72,
    },
    {
      type: "reservation",
      size: 5,
      name: "Dominick Pollard",
      email: "dom@alphanumerics.com",
      date: parseInt(moment().startOf("day").format("X"), 10),
      time: 74,
    },
    {
      type: "reservation",
      size: 2,
      name: "Tiffany Albanese",
      email: "tiffany@thebigshow.com",
      date: parseInt(moment().startOf("day").format("X"), 10),
      time: 78,
    },
    {
      type: "complete",
      table: validTables[0],
      size: 2,
      name: "Henry",
      minAhead: 180,
      waitAhead: 20,
      dineTime: 60,
      tableStatus: 1,
      quoted: 15,
    },
    {
      type: "complete",
      table: validTables[1],
      size: 4,
      name: "Forest",
      minAhead: 120,
      waitAhead: 14,
      dineTime: 80,
      tableStatus: 1,
      quoted: 10,
    },
    {
      type: "complete",
      table: validTables[2],
      size: 6,
      name: "Jamin",
      minAhead: 40,
      waitAhead: 15,
      dineTime: 35,
      tableStatus: 1,
      quoted: 10,
    },
    {
      type: "complete",
      table: validTables[3],
      size: 8,
      name: "Jamin",
      minAhead: 45,
      waitAhead: 20,
      dineTime: 40,
      tableStatus: 1,
      quoted: 15,
    },
    {
      type: "disable",
      table: validTables[5],
    },
    {
      type: "disable",
      table: validTables[6],
    },
  ];
  setTimeout(() => {
    create(kd, opt, data, 0);
  }, 600);
};

const create = (kd, opt, data, index) => {
  const notes = [];
  opt.loc.notes.forEach((note) => {
    notes.push({
      id: note.id,
      value: note.description,
      active: 0,
    });
  });

  const rightNow = parseInt(moment().format("X"), 10);

  let proposed;

  switch (data[index].type) {
    case "seated": {
      // let table = validTables[0];
      const section = getSection(data[index].table, opt.templatedata);
      const server = getServer(opt.loc.assignments, section);
      proposed = {
        domain: "activity",
        status: 3,
        type: 5,
        statusTimes: {
          added: rightNow - 60 * data[index].minAhead,
          seated: rightNow - 60 * data[index].minAhead,
        },
        size: data[index].size,
        tableStatus: data[index].tableStatus,
        notes,
        alerts: 0,
        waited: 0,
        quoted: 0,
        table: data[index].table,
        section,
        server,
        name: data[index].name,
        join: data[index].join,
      };
      break;
    }
    case "wait": {
      // let table = validTables[0];
      proposed = {
        domain: "activity",
        status: 1,
        type: 5,
        statusTimes: {
          added: rightNow - 60 * data[index].minAhead,
          seated: rightNow - 60 * data[index].minAhead,
        },
        size: data[index].size,
        tableStatus: 2,
        notes,
        alerts: 0,
        waited: 0,
        quoted: data[index].quoted,
        preference: l.translate("First Available"),
        name: data[index].name,
      };
      break;
    }
    case "reservation": {
      // let table = validTables[0];
      const section = getSection(data[index].table, opt.templatedata);
      const server = getServer(opt.loc.assignments, section);
      proposed = {
        domain: "reservation",
        status: 1,
        type: 5,
        date: data[index].date,
        time: data[index].time,
        cell: "",
        email: data[index].email,
        size: data[index].size,
        notes,
        alerts: 0,
        waited: 0,
        preference: l.translate("First Available"),
        section,
        server,
        name: data[index].name,
        sendConfirmation: 0,
        requireConfirmation: 0,
        createdBy: "",
      };
      break;
    }
    case "complete": {
      // let table = validTables[0];
      const section = getSection(data[index].table, opt.templatedata);
      const server = getServer(opt.loc.assignments, section);
      proposed = {
        domain: "activity",
        status: 5,
        type: 5,
        statusTimes: {
          added: rightNow - 60 * data[index].minAhead,
          seated:
            rightNow - (60 * data[index].minAhead - 60 * data[index].waitAhead),
          closed:
            rightNow - (60 * data[index].minAhead - 60 * data[index].dineTime),
        },
        size: data[index].size,
        tableStatus: data[index].tableStatus,
        notes,
        alerts: 0,
        waited: data[index].waitAhead,
        quoted: data[index].quoted,
        table: data[index].table,
        section,
        server,
        name: data[index].name,
        alerted: 0,
        callAhead: 0,
        cell: "",
        checkin: 1,
        customNotes: "",
        email: "",
        join: [],
        preference: l.translate("First Available"),
        res_id: 0,
        trigger: [""],
        preSelect: [],
      };
      break;
    }
    case "disable": {
      const disabledTables = opt.loc.disabledTables;
      disabledTables.push(data[index].table);
      proposed = {
        domain: "location",
        disabledTables,
      };
      break;
    }
    default: {
      break;
    }
  }

  kd.update(proposed)
    .then((result) => {
      if (data.length > index + 1) {
        create(kd, opt, data, ++index);
      } else {
        console.log("Demo data added.");
      }
      return true;
    })
    .catch((err3) => {
      console.log("err3", err3);
    });
};

const getSection = (table, templatedata) => {
  for (let i = 0; i < templatedata.tables.length; ++i) {
    if (templatedata.tables[i].table == table) {
      return templatedata.tables[i].section;
    }
  }
  return 0;
};

const getServer = (assignments, section) => {
  for (let i = 0; i < assignments.length; ++i) {
    if (assignments[i].section == section) {
      return assignments[i].server;
    }
  }
  return section;
};

module.exports = {
  start,
};



/** WEBPACK FOOTER **
 ** ./src/controllers/demo/index.js
 **/